import { Injectable, OnDestroy, } from '@angular/core';
import {SubscriptionWsi} from 'core-dashboard';
import { DataProvider,ParameterService,Widget,DashboardConfigManager,AuthService,LogService,WSIValueService,GaugeResponseObject,Value, ValueDetails,WsiUtilityService } from "core-dashboard";
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Subscription} from "rxjs";

/*
This provider can be used to read and subscribe object covs for a given OjectId or PropertyId.
Initial data response is pushed to Widget's Draw method, and subsequent notification are pushed via the Widget's Update method.
*/
@Injectable()
export class EMLPWSIObjectValueProvider implements DataProvider, OnDestroy {

    widget: Widget;
    config: any;
    pointName = "";
    valueAPIUrl = '/api/values/';
    propertyAPIUrl = '/api/properties/'
    private clientID: string;
    private valuesSubscription: Subscription;
    private errorMessage: any;
    private widgetDrawn: boolean = false;
    private dpName: string = "";
    private unit: string = "";
    private descriptor: string = "";
    private _subscriptionInfoPerRequestedObjectOrPropertyId: Map<string, SubscriptionWsi>;
    constructor(private authService: AuthService,
        private parameterService: ParameterService,
        private http: HttpClient,
        private loggerHelper: LogService,
        private wsiHelper: WsiUtilityService,
        private dashboardConfig: DashboardConfigManager,
        private valueService: WSIValueService) {

    }

    public ngOnDestroy(): void {
        this.dispose();
    }

    //this is to get reduced COV data if required
    getReducedCovData(tData:any){
        
    }
    getData(w: Widget) {
        this.widget = w;
        this.config = this.widget.getConfig();
        try {
            if (this.config.pointName) {
                this.pointName = this.config.pointName;
                if (this.pointName == "") {
                    this.widget.Draw(null);
                    throw new Error("Invalid point name in URL.");
                }
            }
            if (this.authService.HasValidSSO() && this.authService.HasValidToken() === false) {
                this.authService.LoginWithSSO().subscribe(
                    (response:HttpResponse<any>) => {
                        if (response) {
                            this.GetInitialValue();
                        }
                    }, error => {
                        //this code will get executed when base URL path is inccorrect
                        this.loggerHelper.logWarning("EMLPWSIObjectValueProvider", "EMLPWSIObjectValueProvider  can not login to desigo cc.");
                        this.widget.Draw(null);
                    });
            }
            else if (this.authService.HasValidToken()) {
                this.GetInitialValue();
            } else {
                this.loggerHelper.logWarning("EMLPWSIObjectValueProvider", "EMLPWSIObjectValueProvider  can not login to desigo cc.");
                this.widget.Draw(null);
            }
        }
        catch (error) {
            this.loggerHelper.logError("EMLPWSIObjectValueProvider", "Error in response : " + error);
            this.widget.Draw(null);
        }
    }

    // this will zoom the widget
    zoom(zoomFrom: any, zoomTo: any) {
    }


    private GetInitialValue() {
        //let headers = this.wsiHelper.httpGetDefaultHeader(this.authService.getToken());
        let headers: HttpHeaders ;
        let authToken= this.authService.getToken();
         if (authToken !== undefined) {
             headers = new HttpHeaders({"Accept": "application/json","Authorization":"Bearer " + authToken,"Access-Control-Allow-Origin": "*"});
        }else{
            headers = new HttpHeaders({"Accept": "application/json","Access-Control-Allow-Origin": "*"});
        }
        let valueUrl: string = this.dashboardConfig.getBaseUrl() + this.valueAPIUrl + this.pointName+"?readMaxAge=-1";
        let propertyUrl: string = this.dashboardConfig.getBaseUrl() + this.propertyAPIUrl + this.pointName;
        this.loggerHelper.logInfo("EMLPWSIObjectValueProvider", "Calling WSI API");
        this.http.get(valueUrl, {
            headers: headers
        }).subscribe((res:HttpResponse<any>) => {
            this.loggerHelper.logInfo("EMLPWSIObjectValueProvider", "Received response." + res);
            try {
                if (res.status < 200 || res.status >= 300) {
                    this.widget.Draw(null);
                    throw new Error("Bad response status: " + res.status);
                }
                this.http.get(propertyUrl, {
                    headers: headers
                }).subscribe((res2:HttpResponse<any>) => {
                    if (res2.status < 200 || res2.status >= 300) {
                        this.widget.Draw(null);
                        throw new Error("Bad response status: " + res2.status);
                    }
                    let result1: any = res;//.json();
                    let result2: any = res2;//.json();
                    if (result1 && result1[0].Value && result2 && result2[0].Properties[0] != null) {
                        var value = result1[0].Value;
                        var property = result2[0].Properties[0];
                        var responseObject: GaugeResponseObject =
                            {
                                ObjectId: (result2[0].ObjectId) ?
                                    result2[0].ObjectId : result1[0].ObjectId ? result1[0].ObjectId : undefined,

                                PropertyName: (property.PropertyName) ?
                                    property.PropertyName : undefined,

                                Value: (value.Value != null && value.Value != undefined) ?
                                    value.Value : undefined,

                                DisplayValue: (value.Value != null && value.Value != undefined) ?
                                    value.Value : undefined,

                                Unit: (property.UnitDescriptor != null && property.UnitDescriptor != undefined) ?
                                    property.UnitDescriptor : undefined,

                                QualityGood: value.QualityGood,

                                DataPointName: property.Descriptor ? property.Descriptor : undefined,
                                IsMultiState: this.checkIfMultistate(value)
                            };
                        this.unit = responseObject.Unit;
                        this.descriptor = responseObject.DataPointName;
                        this.extraValueDetails(responseObject);
                    }
                    else {
                        this.loggerHelper.logError("EMLPWSIObjectValueProvider", "Error while processing response for point name: " + this.pointName);
                        this.widget.Draw(null);
                    }
                })
            }
            catch (error) {
                this.loggerHelper.logError("EMLPWSIObjectValueProvider", "Error in response : " + error);
            }
            this.CreateSubscription();
        }, (error) => {
            //TODO:
            // this section of code was part of processError() method
            //because widget and loggerhelper are losing their references , moving code to inline method
            //this needs more investigation and code refactor
            let errMsg: any = (error && error.message) ? error.message : "Server error";
            if (this.loggerHelper)
                this.loggerHelper.logError("DesigoccObjectValueProvider", "Error in received from service: " + errMsg);
            if (this.widget)
                this.widget.Draw(null);
        });
    }

    private CreateSubscription() {
        this.loggerHelper.logInfo(EMLPWSIObjectValueProvider.name + ":GetObjectValue", "Subscribed for Events");
        if (this.clientID === undefined) {
            this._subscriptionInfoPerRequestedObjectOrPropertyId = new Map<string, SubscriptionWsi>();
            this.clientID = this.valueService.createClientId(EMLPWSIObjectValueProvider.name);
            //How we process indications when they come up.  This does NOT actually subscribe for value changes on any object
            this.valuesSubscription = this.valueService.valueChangeNotification(this.clientID).subscribe({
               next:(valueDetails) => this.onValueChange(valueDetails), error:(error) => this.errorMessage = <any>error
        });
        }
        let ids: string[] = [this.pointName];
        this.valueService.subscribeValues(ids, true, this.clientID).subscribe(
            (subscriptions) => this.onSubscribeValues(subscriptions, ids), error => this.errorMessage = <any>error
        );
    }

    private onValueChange(valuesDetails: ValueDetails[]): void {        
        var responseObject: GaugeResponseObject =
            {
                ObjectId: (valuesDetails[0].ObjectId) ?
                    valuesDetails[0].ObjectId : undefined,
                PropertyName: (valuesDetails[0].PropertyName) ?
                    valuesDetails[0].PropertyName : undefined,

                Value: (valuesDetails[0].Value != null && valuesDetails[0].Value != undefined) ?
                    parseFloat(valuesDetails[0].Value.Value) : undefined,

                DisplayValue: (valuesDetails[0].Value != null && valuesDetails[0].Value != undefined) ?
                    valuesDetails[0].Value.DisplayValue : "undefined",

                Unit: this.unit,

                QualityGood: valuesDetails[0].Value.QualityGood,

                DataPointName: this.descriptor,

                IsMultiState: this.checkIfMultistate(valuesDetails[0].Value)
            };
        this.extraValueDetails(responseObject);
        this.loggerHelper.logInfo(EMLPWSIObjectValueProvider.name + ":onValueChange", JSON.stringify(valuesDetails));
    }
    private checkIfMultistate(property: any): boolean {
        return property.Type === "ExtendedEnum" ? true : false;
    }
    private extraValueDetails(responseObject: GaugeResponseObject) {
        let systemName = this.pointName.split(':')[0];
        let point = this.pointName.split(':')[1];
        let systemId = 0;
        let points: any[] = [];
        try {

            if (!this.widgetDrawn) {
                //let headers = this.wsiHelper.httpGetDefaultHeader(this.authService.getToken());
                let headers: HttpHeaders ;
                let authToken= this.authService.getToken();
                if (authToken !== undefined) {
                    headers = new HttpHeaders({"Accept": "application/json","Authorization":"Bearer " + authToken,"Access-Control-Allow-Origin": "*"});
                }
                else{
                       headers = new HttpHeaders({"Accept": "application/json","Access-Control-Allow-Origin": "*"});
                    }
                systemId = this.dashboardConfig.hasSystemData && (this.dashboardConfig.systemData.find(x => x.Name === systemName)) ? (this.dashboardConfig.systemData.find(x => x.Name === systemName)).Id : systemId;
                points.push(this.pointName);
                //let requestOptions = new RequestOptions({ headers: headers });
                let descriptorUrl = this.dashboardConfig.getBaseUrl() + "/api/systembrowser/" + systemId;
                this.http.post(descriptorUrl, points, { headers: headers}).subscribe((result:HttpResponse<any>) => {
                    let system:any = result;//.json();
                    let dpName = system && system.length > 0 && system[0].Nodes.length > 0 ? system[0].Nodes[0].Name : null;
                    let deviceDescriptor = system && system.length > 0 && system[0].Nodes.length > 0 ? system[0].Nodes.find(x=>x.Location.includes(".Powermanager."))?system[0].Nodes.find(x=>x.Location.includes(".Powermanager.")).Descriptor:null : null;
                    let showDeviceDescription = this.widget.Config.LabelConfiguration && this.widget.Config.LabelConfiguration.DisplayDeviceDescriptor ? this.widget.Config.LabelConfiguration.DisplayDeviceDescriptor : undefined;
                    let showPropertyDescriptor = this.widget.Config.LabelConfiguration && this.widget.Config.LabelConfiguration.DisplayPropertyDescriptor ? this.widget.Config.LabelConfiguration.DisplayPropertyDescriptor : undefined;
                    this.dpName = showPropertyDescriptor && showDeviceDescription ? deviceDescriptor + " [" + responseObject.DataPointName + "]" : showDeviceDescription ? deviceDescriptor : responseObject.DataPointName;
                    responseObject.DataPointName = this.dpName;
                    this.loggerHelper.logInfo(EMLPWSIObjectValueProvider.name + ":extraValueDetails", "Draw on Widget Called.");
                    this.widget.Draw(responseObject);
                    this.widgetDrawn = true;
                }, error => {
                    this.loggerHelper.logError(EMLPWSIObjectValueProvider.name + "", error);
                })
            }
            else {
                this.loggerHelper.logInfo(EMLPWSIObjectValueProvider.name + ":extraValueDetails", "Update on Widget Called.");
                this.widget.Update(responseObject);
            }
        }
        catch (error) {
            this.loggerHelper.logError("EMLPWSIObjectValueProvider", "Error in extraValueDetails : " + error);
            this.widget.Draw(null);
        }
    }

    private onSubscribeValues(subscriptions: SubscriptionWsi[], properties: string[]): void {
        properties.forEach((value, index, array) => {
            this.loggerHelper.logInfo(EMLPWSIObjectValueProvider.name + ":onSubscribeValues", value);
            if (subscriptions[index].ErrorCode === 0) {
                if (subscriptions[index] != undefined) {
                    this._subscriptionInfoPerRequestedObjectOrPropertyId.set(subscriptions[index].PropertyId, subscriptions[index]);
                }
            }
        });

    }

    private onunSubscribeValues(keys: number[], propertyIds: string[]): void {
        this.loggerHelper.logInfo(EMLPWSIObjectValueProvider.name + ":onunSubscribeValues", propertyIds.toString());
        keys.forEach((value, index, array) => {
            this._subscriptionInfoPerRequestedObjectOrPropertyId.delete(propertyIds[index]);
        })
        this.loggerHelper.logInfo(EMLPWSIObjectValueProvider.name + ":onunSubscribeValues", keys.toString());
    }

    private onunSubscribeError(error: any): void {
        this.loggerHelper.logError(EMLPWSIObjectValueProvider.name + ":onunSubscribeError", error.toString());
    }

    dispose(): void {
        try {
            let keys: number[] = [];
            let PropertyIds: string[] = [];
            this._subscriptionInfoPerRequestedObjectOrPropertyId.forEach((value, index, array) => {
                keys.push(value.Key);
                PropertyIds.push(value.PropertyId);
            });

            this.valueService.unSubscribeValues(keys, this.clientID).subscribe({
               next:(subscriptionDeletes) => this.onunSubscribeValues(keys, PropertyIds),error: (error) => this.onunSubscribeError(error)});

            if (this.valuesSubscription != undefined) {
                this.valuesSubscription.unsubscribe();
            }
            this.valueService.disposeClientId(this.clientID);
        }
        catch (error) {
            this.loggerHelper.logError(EMLPWSIObjectValueProvider.name + ":dispose", "Unsubscribed for client failed with error :" + error);
        }
        this.loggerHelper.logInfo(EMLPWSIObjectValueProvider.name + ":dispose", "Unsubscribed for client :" + this.clientID);
    }

}



